<template>
  <v-layout v-if="show">
    <v-chart :style="style" :options="charts"/>
  </v-layout>
</template>

<script> 
export default {
  props:["not","notShow","notChartType","notUnit","notHeight","notWidth","notColors","notChartData"],
  data: () => ({
    show:false, 
     
  }),
  mounted() { 
    console.log(this.notChartData,'...............');
    this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
  },
  computed: {
    vs(){
      return this.not.vs
    },
    vs_width(){
      return this.vs.width
    },
    style(){
      let h = "400px"
      let w = "100%"
      if (this.notWidth) {
        w = this.notWidth
      }
      if (this.notHeight) {
        h=this.notHeight
      }
      return "width: "+w+"; height:"+h+";"
    },
    charts(){ 
      let data =   this.notChartData
      if (this.notUnit==="Percentage") {
        data = this.percentage(data)
      }else if (this.notUnit==="%") {
        data = this.percentage(data)
      }
      let chartData = this.combination(data) 
      let ch = this.processChart(chartData)
      return ch
    }, 

  },
  methods:{
    percentage(data){
      if (!data) {
        return null
      }

      let TOTAL = 0 
      data.forEach(it => {
        TOTAL = TOTAL+(it.value*1)
      });
      data.forEach(it => {
        let t = (it.value*100)/TOTAL
        it.value = t.toFixed(2);
      });
      return data
    },
    processChart(barData,  toolboxPadding = 550){
      if (!barData) {return null} 
      let gr1 ={x: 88, x2:110, y: 8,y2: 150,width: "87%"}
      let gr2 ={ x: 40,x2: 40,y: 15,y2: 70,width: "80%",}
      let unitValue = this.notChartType==="question"?"q":"Votes"
      let  chart = {
            // title: {
            //     text: 'ECharts entry example'
            // },
            // Setup grid
            grid: this.notChartType==="question"?gr2:gr1,
            // grid: {
            //     left: '5%',
            //     right: '80%',
            //     bottom: '3%',
            //     containLabel: true
            // },
           color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0, color: '#C9C9C9' // color at 0% position
                }, {
                    offset: 0, color: '#006180' // color at 100% position
                }],
                global: false // false by default
            },
            width:"88%",
            // Add tooltip
            tooltip: {
               trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }, 
            }, 
            // Add legend
            legend: {
                data: []
            },
            // Add toolbox
            toolbox: {
                show: true,
                orient: 'verticle',
                x: 'right',
                y: 'top',
                //  left: 20, 
                feature: {
                    mark: {
                        show: true,
                        title: {
                            mark: 'Markline switch',
                            markUndo: 'Undo markline',
                            markClear: 'Clear markline'
                        }
                    },
                    dataView: {
                        show: true,
                        readOnly: false,
                        title: 'View data',
                        lang: ['View chart data', 'Close', 'Update']
                    },
                    magicType: {
                        show: true,
                        title: {
                            line: 'Switch to line chart',
                            bar: 'Switch to bar chart'

                        },
                        type: ['line', 'bar']
                    },
                    restore: {
                        show: true,
                        title: 'Restore'
                    },
                    saveAsImage: {
                        show: true,
                        title: 'Same as image',
                        lang: ['Save']
                    }
                }
            },

            // Enable drag recalculate
            calculable: true,

            // Horizontal axis
            xAxis: [{
               
                type: 'category',
                data: barData.labels,
                axisLabel: {
                    interval: 0,
                    rotate: 30,
                }, 
            }],

            // Vertical axis
            yAxis: [{
                type: 'value',
                name: "", 
                nameTextStyle:{
                    align: 'right',
                    padding: [0,0,10,100],
                    
                },
                axisLabel: {
                    formatter: '{value}'+(this.notUnit==="Percentage"?'% ':unitValue),
                    interval: 0,
                    rotate: 10,
                    
                },
            }],

            // Add series
            series: [
                {
                    name: 'Results',
                    type: 'bar',
                    barWidth: '60%', 
                    data: barData.collection ,
                    label: {
                      
                      normal: {
                        show: true,
                        position: 'inside',
                        formatter: v=>
                        {
                           return v.value+(this.notUnit==="Percentage"?' % ':unitValue)   
                        }
                          
                      },
                    },
                }
            ]
        }
        return chart;
    }, 
    combination(chartData){
        if (!chartData) {return null} 
        let labels = []
        let color = []
        chartData.forEach(it => {
          labels.push(it.name)
          color.push({
             offset: 0, color: it.party_color
          })
        });  
        return {
          labels:labels,
          collection:chartData,
          color:color
        };
    }
  },
  watch: {
    notShow(v){
      this.show =v
    },
    notHeight(v){
      this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
    },
    notChartData(v){ 
      // this.show = false
      // setTimeout(() => {
      //   this.show = this.notShow
      // }, 100); 
    },
    vs_width(v){
      this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
    }
  },
};
</script>
